export const BUILD_VERSION = '1788952317327';
